import { useState } from "react"
import { Button, message, Modal, Select } from "antd"
import { swimminglyApi, gen } from "./utils"
import { updateSeasonMeetArrayListener } from "./MeetSchedulePageNew"
import { IClubSeasonInformation } from "./MeetActionsModal"

const { Option } = Select

type TCourseLabel = "SCY" | "SCM" | "LCM"

interface IUpdateMeetCourseMyMeetProps {
  meetId: number
  visible: boolean
  setVisible: (newVisible: boolean) => void
  clubSeason: IClubSeasonInformation | null
  currentCourse: TCourseLabel | null
  refresh: () => void
}

const courseToNumericValue = (course: TCourseLabel | null): number | null => {
  if (course === "SCY") return 0
  if (course === "SCM") return 1
  if (course === "LCM") return 2
  return null
}

export default function UpdateMeetCourseMyMeet({
  meetId,
  visible,
  setVisible,
  clubSeason,
  currentCourse,
  refresh,
}: IUpdateMeetCourseMyMeetProps): JSX.Element {
  const [newCourse, setNewCourse] = useState<number | null>(null)
  const [loading, setLoading] = useState(false)

  const currentCourseValue = courseToNumericValue(currentCourse)
  const isOkDisabled = newCourse === null || newCourse === currentCourseValue

  const closeModal = () => {
    setVisible(false)
    setNewCourse(null)
  }

  const onOk = () => {
    if (isOkDisabled) {
      return
    }

    setLoading(true)
    swimminglyApi
      .post(gen("/api/updateMeetCourse"))
      .body({ meetId, newCourse })
      .then((data) => {
        if (!data || data.status === "error") {
          console.error(data || "outcome not found")
          message.error("Uh oh, something went wrong...")
        } else {
          message.success("You've successfully updated your meet course!")
          closeModal()
          refresh()
          if (clubSeason) {
            updateSeasonMeetArrayListener.emit(
              `updateSeasonMeets${clubSeason.clubSeasonId}`,
            )
          }
        }
      })
      .finally(() => setLoading(false))
  }

  const onCancel = () => {
    closeModal()
  }

  return (
    <Modal
      title="Update My Meet Course"
      open={visible}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={onOk}
          disabled={isOkDisabled}
        >
          Ok
        </Button>,
      ]}
    >
      <div>
        <p>
          Choose the course used for your team&apos;s leg of this virtual meet.
        </p>
        <p>
          Current My Meet Course: <strong>{currentCourse || "Unknown"}</strong>
        </p>
        <Select
          style={{ minWidth: "180px" }}
          value={newCourse ?? currentCourseValue ?? -1}
          onChange={(value) => setNewCourse(value === -1 ? null : value)}
        >
          <Option value={-1} disabled>
            Choose course...
          </Option>
          <Option value={0}>SCY</Option>
          <Option value={1}>SCM</Option>
          <Option value={2}>LCM</Option>
        </Select>
      </div>
    </Modal>
  )
}
